// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rRFg","type":"styles_type__3KQc8","choices":"styles_choices__3hmDJ"};